// 货站明细
export const siteConfig = {
    configuration: true,
    table: {
        leftWidth: 100,
        height: 400,
        columns: [
            {
                label: '货站序号',
                prop: 'stationNumber',
                sort: true,
                width: 140
            },
            {
                label: '转单类型',
                prop: 'operationCodeName',
                sort: true,
                width: 140
            },
            {
                label: '货站名称',
                prop: 'stationName',
                sort: true,
                width: 140
            },
            {
                label: '货站地址',
                prop: 'stationAddress',
                sort: true,
                width: 200
            },
            {
                label: '抵达状态',
                prop: 'arrivalStatusName',
                sort: true,
                width: 120
            },
            {
                label: '单量',
                prop: 'taskCount',
                sort: true,
                width: 80
            },
            {
                label: '总重量(kg)',
                prop: 'totalGrossWeight',
                sort: true,
                width: 80
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume',
                sort: true,
                width: 80
            },
            {
                label: '抵达时间',
                prop: 'stationArrivalTime',
                sort: true,
                width: 180
            },
            {
                label: '抵达方式',
                prop: 'stationArrivalWayName',
                sort: true,
                width: 140
            },
            {
                label: '抵达操作人',
                prop: 'stationUpdateUserCode',
                sort: true,
                width: 120
            }
        ],
        action: {
            fixedWidth: 80,
            list: [
                {
                    type: 'text',
                    label: '抵达货站',
                    size: 'mini',
                    event: 'shipTo',
                    displayRule: function (row) {
                        return +row.isShowButton === 1;
                    }
                }
            ]
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [
            10,
            20,
            30,
            50
        ]
    },
    form: {
        dispatchNo: '',
        shippingType: '',
        actualcarType: '',
        iflowStatusName: '',
        suppliersNameCn: '',
        noCarCarrierName: '',
        tranName: '',
        branchName: '',
        escoCompanyNameCn: '',
        bringBackWay: '',
        remark: '',
        infoCost: ''
    }
};

export const tabSList = [
    {
        name: 'siteDetails',
        label: '货站明细'
    }
];
